import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';
import { isBaseLevel as getIsBaseLevel } from '../../common/utils/hierarchy-enriched-items';

export const getContainerHeight = ({
	level,
	itemHeight,
	depth,
}: {
	level: number;
	itemHeight: number;
	depth: number;
}) => {
	const isBaseLevel = getIsBaseLevel(level);
	let height = isBaseLevel ? token('space.400', '32px') : `${itemHeight}px`;

	if (ff('jwm.visual-hierarchy-milestone-1')) {
		height = depth > 0 ? token('space.400', '32px') : `${itemHeight}px`;
	}

	return height;
};
